import { useMutation } from '@tanstack/react-query';
import api from '../../services/api';

export const MUTATION_KEY_TOTEM_SEND_RELOAD_APP = 'TOTEM_SEND_RELOAD_APP';

interface useSendReloadAppParams {
    totemId: number | undefined;
}

export function useSendReloadApp() {
    const mutationFn = async (params: useSendReloadAppParams) => {
        if (!params.totemId) return null;

        const { totemId } = params;
        try {
            const { data } = await api.post<{
                message: string;
                sentCommand: {
                    totem_id: number;
                    command: string;
                    success: boolean;
                };
            }>('/totem/send-reload-command', {
                totemId,
            });

            return data;
        } catch (error: any) {
            throw new Error(error);
        }
    };

    return useMutation({
        mutationFn,
        mutationKey: [MUTATION_KEY_TOTEM_SEND_RELOAD_APP],
    });
}
